<div class="iframe-container">
    <app-drag-handle />
    <iframe 
        sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-presentation"
        frameborder="0"
        [src]="urlIframe"
    ></iframe>
</div>

